<template>
  <div>
    <slot :list="list"></slot>
    <el-pagination
      v-if="total > 0 && (total > size || alwaysShowPager)"
      class="pager"
      background
      :layout="layout"
      :total="total"
      :page-size="size"
      :page-sizes="pageSizes"
      :current-page="page"
      @current-change="changePage"
      @size-change="changeSize"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  name: "List",
  props: {
    url: {
      type: String,
    },
    method: {
      type: String,
      default: "get",
    },
    search: {
      type: Object,
    },
    alwaysShowPager: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 10,
    },
    showSizes: {
      type: Boolean,
      default: false,
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 20, 30, 40, 50, 100];
      },
    },
    autoGetData: {
      type: Boolean,
      default: true,
    },
    pageHandle: {
      type: Function,
    },
    initPage: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    layout() {
      if (this.showSizes) {
        return "total, prev, pager, next, sizes";
      }
      return "total, prev, pager, next";
    },
  },
  data() {
    return {
      list: [],
      page: 1,
      total: 0,
      size: this.limit,
    };
  },
  async created() {
    this.page = this.initPage;
    if (this.autoGetData) {
      await this.getData();
    }
  },
  methods: {
    async getData() {
      let data = await this.$http[this.method](this.url, {
        page: this.page,
        limit: this.size,
        ...(this.search || {}),
      });
      this.list = data.list;
      this.total = data.total;
      this.$emit("page-load", { list: data.list });
    },
    async searchRefresh() {
      this.$nextTick(async () => {
        this.page = this.initPage || 1;
        await this.getData();
      });
    },
    async changePage(page) {
      if (this.pageHandle) {
        this.pageHandle(page);
      } else {
        this.page = page;
        await this.getData();
      }
    },
    async changeSize(size) {
      this.size = size;
      await this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
.pager {
  margin: 0;
  /deep/ {
    button {
      min-width: 32px;
      padding: 0 6px;
      color: #999999 !important;
      background: transparent !important;

      &[disabled] {
        opacity: 0.5;
      }
    }
    .el-pagination__total {
      height: 32px;
      line-height: 32px;
      margin-right: 16px;
    }
    .btn-prev {
      margin: 0 8px 0 0 !important;
    }
    .btn-next {
      margin: 0 0 0 8px !important;
    }
    .el-pager {
      li {
        margin: 0 8px 0 0 !important;
        color: #666666;
        background: transparent !important;
        &:last-child {
          margin-right: 0 !important;
        }
      }
      .number.active {
        border: 1px solid $primary-color !important;
        color: $primary-color;
      }
    }
    .el-pagination__sizes {
      height: 32px;
      line-height: 32px;

      .el-input {
        margin: 0 0 0 16px;
      }

      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
  }
}
</style>